import React from "react";
/* asset imports */
import grainCart1 from "../assets/images/grains/grains-1.png";
import grainCart2 from "../assets/images/grains/grains-2.png";
import grainCart3 from "../assets/images/grains/grains-3.png";
import MainCartModal from "./modals/MainCartModal";

const GrainsCartLarge = ({
  handleCartClick,
  handleCartItemClick,
  activeCartData,
}) => {
  return (
    <>
      <div className="carts-main-wrapper">
        <div className="close-icon" onClick={() => handleCartClick(0)}>
          <span className="material-symbols-rounded">close</span>
        </div>
        <div className="cart-large grains-cart-empty">
          <img
            src={grainCart1}
            alt=""
            className="inner-img-var-2-1"
            onClick={() => handleCartItemClick("whole-grains")}
          />
          <img
            src={grainCart2}
            alt=""
            className="inner-img-var-2-2"
            onClick={() => handleCartItemClick("ancient-grains")}
          />
          <img
            src={grainCart3}
            alt=""
            className="inner-img-var-2-3"
            onClick={() => handleCartItemClick("sprouted-grains")}
          />
        </div>
      </div>
      <MainCartModal activeCartData={activeCartData} />
    </>
  );
};

export default GrainsCartLarge;
